import React, { useState, useEffect } from 'react';
import Modal from '../Modal';

// Shared add/edit modal for a plant family's name + description.
// The parent owns the API call (via onSubmit) and the submitting state.
const FamilyModal = ({ isOpen, mode = 'add', initialFamily = '', initialDescription = '', submitting = false, onClose, onSubmit }) => {
	const [family, setFamily] = useState(initialFamily);
	const [description, setDescription] = useState(initialDescription);

	useEffect(() => {
		if (isOpen) {
			setFamily(initialFamily);
			setDescription(initialDescription);
		}
	}, [isOpen, initialFamily, initialDescription]);

	const isEdit = mode === 'edit';
	const canSubmit = family.trim().length > 0 && !submitting;

	const submit = () => {
		if (!canSubmit) return;
		onSubmit(family.trim(), description.trim());
	};

	const submitLabel = submitting ? (isEdit ? 'Saving...' : 'Adding...') : isEdit ? 'Save' : 'Add & configure';

	return (
		<Modal isOpen={isOpen} onClose={onClose} title={isEdit ? 'Edit plant family' : 'Add plant family'}>
			<div className="space-y-4">
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">Family name</label>
					<input
						type="text"
						value={family}
						onChange={(e) => setFamily(e.target.value)}
						data-testid="family-name"
						placeholder="e.g. Araceae"
						autoFocus
						onKeyDown={(e) => e.key === 'Enter' && submit()}
						className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
					/>
				</div>
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">
						Description <span className="text-gray-400">(optional)</span>
					</label>
					<textarea
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						rows={2}
						className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
					/>
				</div>
				<div className="flex justify-end gap-2 mt-6">
					<button onClick={onClose} data-testid="family-cancel" disabled={submitting} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
						Cancel
					</button>
					<button onClick={submit} data-testid="family-submit" disabled={!canSubmit} className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
						{submitLabel}
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default FamilyModal;
